module.exports = __webpack_public_path__ + "img/garden_with_herbs_7.a98452e0.png";